import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export default function ArticleDetail() {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    axios
      .get(`${API_URL}/api/articles/show.json?id=${id}`)
      .then((res) => {
        setArticle(res.data.article);
        setLoading(false);
      })
      .catch(() => {
        setError('Article not found.');
        setLoading(false);
      });
  }, [id]);

  function formatDate(dateStr) {
    if (!dateStr) return '';
    return new Date(dateStr).toLocaleDateString('en-US', {
      year: 'numeric', month: 'long', day: 'numeric',
    });
  }

  if (loading) return <div style={styles.page}><div style={styles.centered}>Loading...</div></div>;
  if (error || !article) return (
    <div style={styles.page}>
      <div style={styles.centered}>{error || 'Not found.'} <Link to="/">← Back</Link></div>
    </div>
  );

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <Link to="/" style={styles.backLink}>← Back to Newsroom</Link>

        <article style={styles.article}>
          <header style={styles.header}>
            <span style={styles.typeBadge}>Article</span>
            <h1 style={styles.title}>{article.title}</h1>
            <div style={styles.meta}>
              <span>By <strong>{article.authorName}</strong></span>
              <span style={styles.metaDot}>·</span>
              <span>{formatDate(article.createdAt)}</span>
            </div>
          </header>

          <div style={styles.body}>
            {article.content.split('\n').map((para, i) =>
              para.trim() ? <p key={i} style={styles.para}>{para}</p> : <br key={i} />
            )}
          </div>
        </article>
      </div>
    </div>
  );
}

const styles = {
  page: { minHeight: '100vh', background: '#f8f9fa', fontFamily: 'system-ui, sans-serif', padding: '2rem 1rem' },
  centered: { textAlign: 'center', padding: '4rem', color: '#666' },
  container: { maxWidth: '800px', margin: '0 auto' },
  backLink: { color: '#888', textDecoration: 'none', fontSize: '0.9rem', display: 'inline-block', marginBottom: '1.5rem' },
  article: { background: '#fff', borderRadius: '10px', padding: '2.5rem', boxShadow: '0 2px 12px rgba(0,0,0,0.08)' },
  header: { borderBottom: '1px solid #f0f0f0', paddingBottom: '1.5rem', marginBottom: '2rem' },
  typeBadge: {
    display: 'inline-block',
    background: '#1a1a2e',
    color: '#fff',
    fontSize: '0.75rem',
    fontWeight: 700,
    padding: '0.2rem 0.7rem',
    borderRadius: '20px',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    marginBottom: '0.75rem',
  },
  title: { margin: '0 0 0.75rem', fontSize: '2rem', lineHeight: 1.3, color: '#1a1a2e' },
  meta: { display: 'flex', alignItems: 'center', gap: '0.4rem', color: '#888', fontSize: '0.85rem' },
  metaDot: { color: '#ccc' },
  body: { color: '#333', lineHeight: 1.8, fontSize: '1rem' },
  para: { margin: '0 0 1.2rem' },
};
